<h3 class="dupes__hed mt-0050 mb-0050"
    *ngIf="matchesFound">
  <i class="fal fa-exclamation-triangle"></i> Potential Duplicates
</h3>
<mat-progress-bar mode="indeterminate"
                  class="mb-0100"
                  *ngIf="isSearching$ | async"></mat-progress-bar>

<mat-selection-list #dupesList
                    class="dupes__list"
                    [ngClass]="{'mb-0100':matchesFound}"
                    [multiple]="false"
                    (selectionChange)="onItemSelected($event)">
  <mat-list-option *ngFor="let match of (matches$ | async)"
                   [value]="match">
    <app-entity-avatar class="match__avatar"
                       matListAvatar
                       size="md"
                       [entityTypeId]="match.entityTypeId"
                       [spotlightIcon]="match.spotlightIcon"
                       [assessmentLevel]="match.currentAssessmentLevel"></app-entity-avatar>
    <div class="match__main">
      <span class="match__name">{{ match | fullName }}</span>
      <span class="match__meta"
            *ngIf="match.bestAddress">{{ match.bestAddress | cityState }}</span>
    </div>
    <span class="match__warn"
          [matTooltip]="getCampaignsTooltip(match)"
          *ngIf="!isInCampaign(match)"><i class="fal fa-exclamation-triangle"></i>
          <span class="d-none d-inline-block--ps">Not in Campaign</span>
        </span>

      <span class="match__warn match__warn--green"
            *ngIf="isInCampaign(match)"
            [matTooltip]="getCampaignsTooltip(match)">
        <i class="fal fa-circle-check"></i>
        <span class="d-none d-inline-block--ps">Entity in Campaign</span>
      </span>
  </mat-list-option>
</mat-selection-list>
